<script lang="ts">
	import { navigating } from '$app/state';
	import { onMount } from 'svelte';

	let progress = $state(0);
	let isNavigating = $state(false);
	let intervalId: ReturnType<typeof setInterval> | null = null;

	// Watch the navigating store
	$effect(() => {
		if (navigating && !navigating.complete) {
			// Start navigation
			isNavigating = true;
			progress = 0;

			// Simulate progress with intervals
			if (intervalId) clearInterval(intervalId);

			intervalId = setInterval(() => {
				// Slow down as we approach 90%
				if (progress < 50) {
					progress += 10;
				} else if (progress < 70) {
					progress += 5;
				} else if (progress < 90) {
					progress += 2;
				} else {
					progress += 0.5;
				}

				// Cap at 95% until navigation completes
				if (progress > 95) {
					progress = 95;
				}
			}, 200);
		} else if (isNavigating) {
			// Navigation complete - finish the bar
			if (intervalId) {
				clearInterval(intervalId);
				intervalId = null;
			}

			progress = 100;

			// Hide after animation completes
			setTimeout(() => {
				isNavigating = false;
				progress = 0;
			}, 300);
		}
	});

	onMount(() => {
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	});
</script>

{#if isNavigating && navigating && !navigating.complete}
	<div
		class="fixed left-0 right-0 top-0 z-[9999] h-px bg-black/80 shadow-[0_0_10px_rgba(0,0,0,0.3)] transition-all duration-200 ease-out dark:bg-white/80 dark:shadow-[0_0_15px_rgba(255,255,255,0.4)]"
		style="width: {progress}%;"
	></div>
{/if}
